import { useAppSelector } from '../../store'
import { selectHabitat } from './selectors'

export const useHabitat = (): string => {
  return useAppSelector(selectHabitat)
}
